"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const graphql_1 = require("../../../../graphql");
const hooks_1 = require("../../hooks");
exports.ConversionCanvasSaveButton = () => {
    const { state: { draft }, pathParams: { cmsId, contentConversionId }, } = hooks_1.useConversionCanvas();
    // const variables = {
    //   contentConversionId,
    //   data: {
    //     type: step.type,
    //     attributeName: step.attributeName,
    //     attributeRemovalStrategy: step.attributeRemovalStrategy || null,
    //     attributeValue: step.attributeValue,
    //     attributes: step.attributes,
    //     cssForATag: step.cssForATag,
    //     cssForImgTag: step.cssForImgTag,
    //     doNothingIfAttributeExists: step.doNothingIfAttributeExists,
    //     fromAttribute: step.fromAttribute,
    //     headHtml: step.headHtml,
    //     imgWidth: step.imgWidth || null,
    //     includedHtml: step.includedHtml,
    //     linkSelector: step.linkSelector,
    //     linkToContentItem: step.linkToContentItem,
    //     linkToFirstLink: step.linkToFirstLink,
    //     name: step.name,
    //     overlayHtml: step.overlayHtml,
    //     removeTarget: step.removeTarget,
    //     selector: step.selector,
    //     textToFind: step.textToFind,
    //     textToReplace: step.textToReplace,
    //     toAttribute: step.toAttribute,
    //   },
    //   id: step.id,
    // };
    const [mutate, mutationResult] = react_hooks_1.useMutation(graphql_1.createOrUpdateConversion, {
        variables: {
            cmsId,
            data: {
                name: draft.name || '',
                steps: draft.steps.map(step => {
                    var _a;
                    // const defaultStep =
                    // TODO: Use the FIELD META obj to do this for all numbers:
                    let newImgWidth = null;
                    if (step.imgWidth) {
                        try {
                            newImgWidth = parseInt(`${step.imgWidth}`, 10);
                        }
                        catch (e) {
                            console.error({ error: e, msg: 'Failed to parse imgWidth' });
                            newImgWidth = null;
                        }
                    }
                    return {
                        adId: (_a = step.ad) === null || _a === void 0 ? void 0 : _a.id,
                        adjacentInsertionPosition: step.adjacentInsertionPosition || 'afterend',
                        attributeName: step.attributeName,
                        attributeRemovalStrategy: step.attributeRemovalStrategy,
                        attributes: step.attributes,
                        attributeValue: step.attributeValue,
                        cssForATag: step.cssForATag,
                        cssForImgTag: step.cssForImgTag,
                        doNothingIfAttributeExists: step.doNothingIfAttributeExists,
                        fromAttribute: step.fromAttribute,
                        headHtml: step.headHtml,
                        id: step.id,
                        imgWidth: newImgWidth,
                        includedHtml: step.includedHtml,
                        linkSelector: step.linkSelector,
                        linkToContentItem: step.linkToContentItem,
                        linkToFirstLink: step.linkToFirstLink,
                        name: step.name,
                        overlayHtml: step.overlayHtml,
                        paused: step.paused,
                        removeTarget: step.removeTarget,
                        selector: step.selector,
                        textToFind: step.textToFind,
                        textToReplace: step.textToReplace,
                        toAttribute: step.toAttribute,
                        type: step.type,
                    };
                }),
            },
            id: contentConversionId,
        },
    });
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: "ConversionCanvasToolbarInner.save", osysStyle: "save", tooltip: "Save", mutate: mutate, mutationResult: mutationResult, renderApolloError: true }, "Save"));
};
//# sourceMappingURL=SaveButton.js.map